import { API_BASE_URL } from 'src/env';
import { ApiReturnType } from 'src/interfaces/api/api';

export default {
  getAll: (): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/gaming/ranks`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
};
